import SharedLocale from '../shared/l10n';
import AuthLocale from '../auth/l10n';
import AffiliationLocale from '../affiliation/l10n';
import ReportLocale from '../report/l10n';
import SettingLocale from '../setting/l10n';

export default {
    fa: {  ...SharedLocale.fa, ...AuthLocale.fa, ...AffiliationLocale.fa, ...SettingLocale.fa, ...ReportLocale.fa },
    en: { ...SharedLocale.en, },
    es: { ...SharedLocale.es, },
};